import router from "@/router";
import store from "@/store";
import UM from "@/api/user-management";
import Cookies from "js-cookie";

router.beforeEach(async (to, from, next) => {
  // 重新取得登入資訊
  // console.info('[GET_INFO] Route change')
  await store.dispatch("user/getInfo");
  const userInfo = JSON.parse(Cookies.get("user") || null) || {};
  const token = store.state.user.access_token
    ? store.state.user.access_token
    : userInfo.access_token;

  const needLoginPages = [
    "Ticket",
    "TicketTab",
    "Order1",
    "SelectSt",
    "ConfirmSt",
    "Order2",
    "Order3",
    "Done",
    "UserInfo",
    "OrderList"
  ];

  const orderPage = ["Order1", "SelectSt", "ConfirmSt", "Order2", "Order3"];

  if (!token) {
    // debugger;
    console.info("[TOKEN] NO TOKEN");
    if (needLoginPages.includes(to.name)) {
      if (!from.name) {
        if (orderPage.includes(to.name))
          next({
            name: "Activity",
            params: {
              id: to.params.eventId
            }
          });
        else next({ name: "Index" });
      }

      Cookies.set("toPath", to.fullPath);
      store.dispatch("login/show");
      return;
    }
  } else {
    let current = new Date();
    let isCallRefresh = Cookies.get("isCallRefresh");

    // console.log(`[TOKEN] ${isCallRefresh} ${current.valueOf() - 5000} ${JSON.parse(Cookies.get("expiredTime"))}`)
    if (
      !isCallRefresh &&
      current.valueOf() - 5000 > JSON.parse(Cookies.get("expiredTime"))
    ) {
      Cookies.set("isCallRefresh", true);
      console.info("[TOKEN] isCallRefresh");
      const { data } = await UM.refreshToken();
      if (data.errCode == "00") {
        console.info("[TOKEN] Refresh Change");
        Cookies.remove("isCallRefresh");
        await store.dispatch("user/refreshToken", data.userInfo);
      } else {
        console.info("[TOKEN] Refresh Failed", data);
        Cookies.remove("isCallRefresh");
        store.dispatch("user/logout");
        store.dispatch("login/show");
      }
    }

    let isVerify = store.state.user.verifyEmail
      ? store.state.user.verifyEmail
      : userInfo.verifyEmail;

    if (to.meta.order && !isVerify && this.$t) {
      store.dispatch("dialog/show", {
        error: true,
        title: this.$t("permission_title"),
        content: this.$t("permission_content"),
        button: this.$t("permission_cta"),
        redirectPathName: "UserInfo"
      });
    }
  }

  next(); // 有權限
  return;
});
